import { render, staticRenderFns } from "./CaseManagementCard.vue?vue&type=template&id=47f17458&scoped=true&"
import script from "./CaseManagementCard.vue?vue&type=script&lang=js&"
export * from "./CaseManagementCard.vue?vue&type=script&lang=js&"
import style0 from "./CaseManagementCard.vue?vue&type=style&index=0&id=47f17458&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f17458",
  null
  
)

export default component.exports